import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e2e34c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex h-[40px] items-center w-full" }
const _hoisted_2 = ["onContextmenu"]
const _hoisted_3 = { class: "agents-table--cell-content" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "font-gordita-regular pl-[12px] pr-[19px] flex items-center justify-between bg-System/app_white outline outline-1 outline-System/app_border whitespace-nowrap rounded-b-[2px]" }
const _hoisted_6 = { class: "text-[11px] leading-[15px] mr-[16px] text-Text/text_medium flex items-center" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "text-Text/text_high" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 2,
  class: "flex items-center"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ellipsis-seperator mx-3 w-1 h-1 rounded-[50%] bg-[#374A5080]" }, null, -1))
const _hoisted_14 = { class: "text-Text/text_high" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " in filter", -1))
const _hoisted_16 = {
  key: 3,
  class: "flex items-center mr-3"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ellipsis-seperator mx-3 w-1 h-1 rounded-[50%] bg-[#374A5080]" }, null, -1))
const _hoisted_18 = { class: "text-Text/text_high" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " selected", -1))
const _hoisted_20 = {
  key: 4,
  class: "!pa-0"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "!py-[2px] !px-[4px] font-gordita-regular text-[11px] text-Text/text_medium text-decoration-line: underline" }, " Clear all selected ", -1))
const _hoisted_22 = { class: "flex gap-8 justify-between" }
const _hoisted_23 = { class: "flex items-center gap-[23px] h-[40px] ml-auto" }
const _hoisted_24 = { class: "flex items-center gap-[8px] ml-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-gordita-regular text-[11px] text-Text/text_medium" }, "Show: ", -1))

import elementIds from '@/const/elementIds.json';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { Agent, Agent_QuickFilter, Agent_SortField, Agent_SortOrder, Agent_Type, AgentsQuery } from '@/graphql/codegen/generated/graphql';
import DynamicAgentActionMenu from '@/components/agents-table/DynamicAgentActionMenu.vue';
import { IncrediButton, IncrediPagination, IncrediSelect, IncrediTable, IncrediTooltip } from 'incredi-ui';
import { computed, inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import AgentNameCell from '@/views/agents/components/agents-table/components/AgentRow/Cells/AgentsTableNameCell.vue';
import { useUserRolePermissions } from '@/services/UserRolePermissions/UserRolePermissions';
import AgentsTableStatusCell from '@/views/agents/components/agents-table/components/AgentRow/Cells/AgentsTableStatusCell.vue';
import AgentTableNameCellCompactView from '@/views/agents/components/agents-table/components/AgentRow/Cells/AgentTableNameCellCompactView.vue';
import AgentsAlertsHeader from '@/views/agents/components/agents-table/components/agents-alerts-header.vue';
import { useAgentsTableUtils } from '@/views/agents/components/agents-table/agent-table-list/OS/agents-table.utils';
import { IKAgentsDrawerFilter } from '@/types/injectionKeys';
import EmptyAgentsSearch from '@/components/common/empty-table-placeholder.vue';
import { dateUtils } from '@/services/dateUtils';
import { useAgentRowStyle, useAgentsTableHelpers } from '../../agents-table.helpers';
import { useAgentsTableConstants } from '../../agents-table.const';
import { IKAgentsPersistentData, IKAgentsQueryFilter } from '../../../../agents.injectionKeys';
import TableCell from '../../components/AgentRow/Cells/AgentsTableCell.vue';
import CheckboxCell from '../../components/AgentRow/Cells/AgentsTableCheckboxCell.vue';
import CellWrapper from '../../components/AgentRow/AgentTableCellWrapper.vue';
import FloatingCell from '../../components/AgentRow/Cells/AgentsTableFloatingCell.vue';
import { IKAgentsSelected } from '../../agents-table.InjectionKeys';
import HeaderCheckboxCell from '../../components/Cells/AgentsTableHeaderCheckboxCell.vue';
import AgentsLinuxLicenseCell from '../../components/AgentRow/Cells/AgentsLinuxLicenseCell.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'agents-table.linux',
  props: {
    columns: null,
    agentsQueryResult: null
  },
  emits: ["onScroll"],
  setup(__props: any, { emit }: { emit: ({
  // eslint-disable-next-line no-unused-vars
  (e: 'onScroll', state: { isScrolling: boolean }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  columns: ReturnType<typeof useAgentsTableConstants>['columns']['value'];
  agentsQueryResult: AgentsQuery['agents'];
}

const agentsFilter = inject(IKAgentsDrawerFilter);
const agentsPersistedData = inject(IKAgentsPersistentData);
const agentsTableConstants = useAgentsTableConstants();

const agentsQueryFilter = inject(IKAgentsQueryFilter);
const selectedAgents = inject(IKAgentsSelected);
const isCompactRow = computed(() => agentsPersistedData?.getAgentsTableCompactView.value || false);
onMounted(() => {
  // Need to handle new page size options according to story WIN-15064
  if (agentsQueryFilter?.get.value?.paging?.pageSize === 75) {
    agentsQueryFilter?.set({
      ...agentsQueryFilter?.get.value,
      paging: { ...agentsQueryFilter?.get.value.paging, pageSize: 100 },
    });
  }
});

const userRolePermissions = useUserRolePermissions();
const agentsTableUtils = useAgentsTableUtils();


const { getAgentRowStyle } = useAgentRowStyle();
const isScrolling = ref(false);
const isNameColHovered = ref(false);
const isFloatingMenuOpen = ref<boolean>(false);
const contextMenuOpenedRowIndex = ref<number | undefined>(undefined);
const setIsScrolling = (value: boolean) => {
  if (isScrolling.value !== value) {
    isScrolling.value = value;
    emit('onScroll', { isScrolling: value });
  }
};

const { getMemoryUsage } = useAgentsTableHelpers();
const store = useStore();
const isAgentMenuOpen = ref<boolean>(false);

const isNameHeaderHovered = ref(false);

const secondarySortField = (sortName: keyof typeof agentsTableConstants['mapColumnsToAgentSortField']['value']) => {
  switch (agentsTableConstants.mapColumnsToAgentSortField.value[sortName]) {
    case Agent_SortField.RegisteredCores:
      return Agent_SortField.PhysicalCores;

    case Agent_SortField.InitiatorCores:
      return Agent_SortField.HelperCores;

    default:
      return null;
  }
};
const spotValue = (index: number) => {
  if (!props?.agentsQueryResult?.agents || props.agentsQueryResult.agents[index]?.cloud?.spot === null || props.agentsQueryResult.agents[index]?.cloud?.spot === undefined) {
    return null;
  }
  return props.agentsQueryResult?.agents[index]?.cloud?.spot ? 'Yes' : 'No';
};

// agent that is single use not allowed to do any actions, so context menu won't open
const isAgentSUVM = (agent: Agent | null) => agent?.metadata?.agentType === Agent_Type.SingleUse || agent?.metadata?.agentType === Agent_Type.ExpiredSingleUse;
const toggleFloatingRow = (value: boolean, index: number) => {
  isFloatingMenuOpen.value = value;
  contextMenuOpenedRowIndex.value = value ? index : undefined;
  selectedAgents?.clearSelection();
  if (props.agentsQueryResult?.agents && props.agentsQueryResult?.agents[index]) {
    agentsTableUtils.selectAgent(true, props.agentsQueryResult?.agents[index]);
  }
};

const showAgentNameTooltip = () => {
  setTimeout(() => {
    isNameHeaderHovered.value = true;
  }, 1000);
};

const handleOpenContextMenu = (index: number) => {
  if (
    props.agentsQueryResult?.agents &&
    props.agentsQueryResult?.agents[index] &&
    !isAgentSUVM(props.agentsQueryResult?.agents[index]) &&
    !agentsTableUtils.isCloudAgentInStatusStoppedOrUpdating(props.agentsQueryResult?.agents[index] || {}) &&
    agentsTableUtils.shouldOpenContextMenu()
  ) {
    if (!selectedAgents?.selectedAgentIds.value.has(props?.agentsQueryResult?.agents[index]?.id as string)) {
      selectedAgents?.clearSelection();
      if (props.agentsQueryResult?.agents && props.agentsQueryResult?.agents[index]) {
        agentsTableUtils.selectAgent(true, props.agentsQueryResult?.agents[index]);
      }
      isAgentMenuOpen.value = true;
      contextMenuOpenedRowIndex.value = index;
    } else if (selectedAgents?.selectedAgentIds.value.size === 1) {
      isAgentMenuOpen.value = true;
      contextMenuOpenedRowIndex.value = index;
    } else if (selectedAgents?.selectedAgentIds.value.size > 1) {
      isAgentMenuOpen.value = true;
      contextMenuOpenedRowIndex.value = undefined;
    }
  }
};

const clearFilters = () => {
  agentsFilter?.clearFilters();
  agentsFilter?.setGQL_AgentsQuickFilter('showAll');
  agentsFilter?.setGQL_AgentsSearchFilter('');
  agentsFilter?.clearGQL_AgentsFilter();
};

const totalFilteredAgentsCount = computed(() => props.agentsQueryResult?.totalFilteredCount || 0);
const totalAgentsCount = computed(() => props.agentsQueryResult?.totalCount || 0);
const isSearchFilterApplied = computed(() => !!agentsFilter?.GQL_AgentsFilter?.value?.searchFilter);
const showAgentsTotalInFiltersCount = computed(
  () =>
    totalAgentsCount.value - totalFilteredAgentsCount.value ||
    agentsFilter?.agentsLeftDrawerActiveFilters.value ||
    (agentsFilter?.GQL_AgentsFilter?.value?.quickFilter && agentsFilter?.GQL_AgentsFilter?.value?.quickFilter !== Agent_QuickFilter.All) ||
    agentsFilter?.GQL_AgentsFilter.value.searchFilter,
);

const getAgentSettings = (agent: Agent) => {
  const url = agentsTableUtils.getAgentSettingsUrl(agent, true);
  const win = window.open(url, '_blank');
  win?.focus();
};

return (_ctx: any,_cache: any) => {
  return (_unref(agentsQueryFilter)?.get.value && _unref(agentsQueryFilter)?.set)
    ? (_openBlock(), _createBlock(IbxScopedCss, {
        key: 0,
        class: "flex-grow flex flex-col flex-nowrap"
      }, {
        default: _withCtx(() => [
          _createVNode(DynamicAgentActionMenu, {
            "agents-query-result": __props.agentsQueryResult,
            "context-menu": isAgentMenuOpen.value && !_unref(store).getters['settings/isBackupCoordinator'],
            "before-hide": 
        () => {
          isAgentMenuOpen.value = false;
          contextMenuOpenedRowIndex.value = undefined;
        }
      
          }, null, 8, ["agents-query-result", "context-menu", "before-hide"]),
          (_unref(totalFilteredAgentsCount))
            ? (_openBlock(), _createBlock(_unref(IncrediTable), {
                key: 0,
                "model-value": {
        selection: _unref(userRolePermissions).authorize?.value?.agents.enabled.actions
          ? {
              itemId: 'id',
              items: _unref(selectedAgents)?.selectedAgentIds.value || new Set(),
            }
          : undefined,
        sort: {
          name: _unref(agentsTableConstants).mapAgentSortFieldToColumns.value[_unref(agentsQueryFilter)?.get.value.sort.field],
          descending: _unref(agentsQueryFilter)?.get.value.sort.order === _unref(Agent_SortOrder).Descending,
        },
      },
                "row-height": _unref(isCompactRow) ? 32 : 48,
                "data-testid": _unref(elementIds).agents.AgentsTable,
                class: _normalizeClass(["agents-table flex-grow w-full h-0", {
        'pointer-events-none': isFloatingMenuOpen.value || isAgentMenuOpen.value,
        'alerts-column-header-hovered': _unref(agentsQueryFilter)?.get.value.sort.field !== _unref(Agent_SortField).Name && isNameColHovered.value,
        'alerts-column-header-hovered--name-sorted': _unref(agentsQueryFilter)?.get.value.sort.field === _unref(Agent_SortField).Name && isNameColHovered.value,
      }]),
                columns: __props.columns,
                items: (__props.agentsQueryResult?.agents as any) || [],
                "header-tooltip": true,
                "hovered-row-prop": contextMenuOpenedRowIndex.value,
                onOnDrag: _cache[6] || (_cache[6] = state => setIsScrolling(state)),
                onOnChangeColumnsWidth: _cache[7] || (_cache[7] = col => _unref(agentsTableUtils).updateColumnWidth(col)),
                onOnScroll: _cache[8] || (_cache[8] = state => setIsScrolling(state.isScrolling?.value)),
                "onUpdate:modelValue": _cache[9] || (_cache[9] = 
          tableState => {
            if (!_unref(agentsQueryFilter)) return;
              _unref(agentsTableUtils).handlePageSorting(
              _unref(agentsTableConstants).mapColumnsToAgentSortField.value[tableState.sort?.name as keyof typeof agentsTableConstants['mapColumnsToAgentSortField']['value']],
              tableState.sort?.descending ? _unref(Agent_SortOrder).Descending : _unref(Agent_SortOrder).Ascending,
              secondarySortField(tableState.sort?.name as keyof typeof agentsTableConstants['mapColumnsToAgentSortField']['value']) as any
             )
            _unref(agentsTableUtils).handleAgentsSelection(tableState, __props.agentsQueryResult);
          }
        )
              }, {
                "header-checkbox": _withCtx(({ bind, on }) => [
                  _createVNode(HeaderCheckboxCell, {
                    "data-testid": _unref(elementIds).agents.table.selectAllCheckbox,
                    "model-value": bind.modelValue,
                    "onUpdate:modelValue": newValue => on['update:model-value'](newValue)
                  }, null, 8, ["data-testid", "model-value", "onUpdate:modelValue"])
                ]),
                "header-AgentName": _withCtx(({ column }) => [
                  _createVNode(_unref(IncrediTooltip), {
                    "model-value": isNameHeaderHovered.value,
                    direction: "top-middle",
                    "offset-x": 25,
                    "offset-y": -2,
                    delay: 1000
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(column.name), 1)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(AgentsAlertsHeader, {
                          class: "w-[36px] h-[40px]",
                          "model-value": _unref(agentsQueryFilter)?.get.value.sort,
                          onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (isNameColHovered.value = true)),
                          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isNameColHovered.value = false)),
                          "onUpdate:sort": _cache[2] || (_cache[2] = sort => _unref(agentsQueryFilter)?.set({ ..._unref(agentsQueryFilter)?.get.value, sort }))
                        }, null, 8, ["model-value"]),
                        _createElementVNode("div", {
                          class: "ml-3 w-[calc(100%-48px)] truncate",
                          onMouseenter: showAgentNameTooltip,
                          onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (isNameHeaderHovered.value = false)),
                          onFocusin: showAgentNameTooltip,
                          onFocusout: _cache[4] || (_cache[4] = ($event: any) => (isNameHeaderHovered.value = false)),
                          onClick: _cache[5] || (_cache[5] = 
                () =>
                  _unref(agentsQueryFilter)?.set({
                    ..._unref(agentsQueryFilter)?.get.value,
                    sort: {
                      field: _unref(Agent_SortField).Name,
                      order:
                        _unref(agentsQueryFilter)?.get.value.sort.field === _unref(Agent_SortField).Name
                          ? _unref(agentsQueryFilter)?.get.value.sort.order === _unref(Agent_SortOrder).Ascending
                            ? _unref(Agent_SortOrder).Descending
                            : _unref(Agent_SortOrder).Ascending
                          : _unref(Agent_SortOrder).Ascending,
                    },
                  })
              )
                        }, _toDisplayString(column.name), 33)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["model-value"])
                ]),
                "content-checkbox": _withCtx(({ index, bind }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CheckboxCell, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        disabled: 
            __props.agentsQueryResult?.agents &&
            __props.agentsQueryResult?.agents[index] &&
            (isAgentSUVM(__props.agentsQueryResult?.agents[index]) || _unref(agentsTableUtils).isCloudAgentInStatusStoppedOrUpdating(__props.agentsQueryResult?.agents[index] || {}))
          ,
                        "model-value": bind['model-value'],
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        "onUpdate:modelValue": 
            newValue => {
              if (__props.agentsQueryResult?.agents && __props.agentsQueryResult?.agents[index]) _unref(agentsTableUtils).selectAgent(newValue, __props.agentsQueryResult?.agents[index]);
            }
          
                      }, null, 8, ["data-cy-agent-name", "disabled", "model-value", "agent-metadata", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                "floating-row": _withCtx(({ index, hoveredRow }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.floatingRow,
                        floating: "",
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          (
              !isAgentSUVM(__props.agentsQueryResult?.agents[index]) &&
              !_unref(agentsTableUtils).isCloudAgentInStatusStoppedOrUpdating(__props.agentsQueryResult?.agents[index] || {}) &&
              (index === hoveredRow || contextMenuOpenedRowIndex.value === index)
            )
                            ? (_openBlock(), _createBlock(FloatingCell, {
                                key: 0,
                                agent: __props.agentsQueryResult?.agents[index],
                                onToggleRow: (value) => toggleFloatingRow(value, index)
                              }, null, 8, ["agent", "onToggleRow"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-AgentName": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents && __props.agentsQueryResult?.agents[index] && !_unref(isCompactRow))
                    ? (_openBlock(), _createBlock(AgentNameCell, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.nameCell,
                        class: "h-full",
                        "agent-row-style": _unref(getAgentRowStyle)(__props.agentsQueryResult?.agents[index] || {}, !!_unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')),
                        "agent-data": __props.agentsQueryResult?.agents[index] as any,
                        onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                      }, null, 8, ["data-cy-agent-name", "data-testid", "agent-row-style", "agent-data", "onContextmenu"]))
                    : _createCommentVNode("", true),
                  (__props.agentsQueryResult?.agents && __props.agentsQueryResult?.agents[index] && _unref(isCompactRow))
                    ? (_openBlock(), _createBlock(AgentTableNameCellCompactView, {
                        key: 1,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.nameCell,
                        class: "h-full",
                        "agent-row-style": _unref(getAgentRowStyle)(__props.agentsQueryResult?.agents[index] || {}, !!_unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')),
                        "agent-data": __props.agentsQueryResult?.agents[index] as any,
                        onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                      }, null, 8, ["data-cy-agent-name", "data-testid", "agent-row-style", "agent-data", "onContextmenu"]))
                    : _createCommentVNode("", true)
                ]),
                "content-Status": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.status,
                        "data-testid": _unref(elementIds).agents.table.statusCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(AgentsTableStatusCell, {
                            "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                            value: __props.agentsQueryResult?.agents[index]?.status as any,
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["agent-metadata", "value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-AgentDescription": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.descriptionCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.hostComment,
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-Version": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.agentVersion,
                        "data-testid": _unref(elementIds).agents.table.versionCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.agentVersion?.versionText,
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-IP": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.ipCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          (!__props.agentsQueryResult?.agents[index]?.metadata?.isCloud)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "agents-table--cell",
                                onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                              }, [
                                _createElementVNode("div", _hoisted_3, [
                                  _createElementVNode("span", {
                                    class: "hoverable-agent-settings",
                                    onClick: _withModifiers(($event: any) => (getAgentSettings(__props.agentsQueryResult?.agents[index] as Agent)), ["prevent"])
                                  }, _toDisplayString(__props.agentsQueryResult?.agents[index]?.ip), 9, _hoisted_4)
                                ])
                              ], 40, _hoisted_2))
                            : (_openBlock(), _createBlock(TableCell, {
                                key: 1,
                                value: __props.agentsQueryResult?.agents[index]?.ip,
                                onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                              }, null, 8, ["value", "onContextmenu"]))
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-Subscription": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.licenseCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          (!_unref(agentsTableUtils).isCloudAgentInStatusStoppedOrUpdating(__props.agentsQueryResult?.agents[index] || {}))
                            ? (_openBlock(), _createBlock(AgentsLinuxLicenseCell, {
                                key: 0,
                                value: __props.agentsQueryResult?.agents[index]?.license?.status,
                                onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                              }, null, 8, ["value", "onContextmenu"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-BuildGroup": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.buildGroupCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.metadata?.isCloud ? null : __props.agentsQueryResult?.agents[index]?.buildGroup,
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-AssignedToInitiator": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.AssignedToInitiatorCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.assignedToInitiator,
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-LastConnected": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.lastConnectedCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          (!_unref(agentsTableUtils).isCloudAgentInStatusStoppedOrUpdating(__props.agentsQueryResult?.agents[index] || {}))
                            ? (_openBlock(), _createBlock(TableCell, {
                                key: 0,
                                value: _unref(dateUtils).getFormattedDate(Number(__props.agentsQueryResult?.agents[index]?.lastConnected)) + ' ' + _unref(dateUtils).getFormattedTime(Number(__props.agentsQueryResult?.agents[index]?.lastConnected)),
                                onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                              }, null, 8, ["value", "onContextmenu"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-CPUFrequency": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.CPUFrequencyCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          (!_unref(agentsTableUtils).isCloudAgentInStatusStoppedOrUpdating(__props.agentsQueryResult?.agents[index] || {}))
                            ? (_openBlock(), _createBlock(TableCell, {
                                key: 0,
                                value: `${__props.agentsQueryResult?.agents[index]?.performance?.cpuSpeed} MHz`,
                                onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                              }, null, 8, ["value", "onContextmenu"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-InitiatorHelperActiveCores": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.InitiatorHelperActiveCoresCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          (!_unref(agentsTableUtils).isCloudAgentInStatusStoppedOrUpdating(__props.agentsQueryResult?.agents[index] || {}))
                            ? (_openBlock(), _createBlock(TableCell, {
                                key: 0,
                                value: `${__props.agentsQueryResult?.agents[index]?.license?.initiatorCores} / ${__props.agentsQueryResult?.agents[index]?.license?.helperCores}`,
                                onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                              }, null, 8, ["value", "onContextmenu"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-AvailableMemory": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.availableMemoryCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          (!_unref(agentsTableUtils).isCloudAgentInStatusStoppedOrUpdating(__props.agentsQueryResult?.agents[index] || {}))
                            ? (_openBlock(), _createBlock(TableCell, {
                                key: 0,
                                value: `${_unref(getMemoryUsage)(__props.agentsQueryResult?.agents[index] as any).available} GB`,
                                onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                              }, null, 8, ["value", "onContextmenu"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-OperatingSystem": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.osSystemCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.osVersion,
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-ModelName": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.cpuInfoCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.performance?.cpuInfo,
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-CPULoad": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.CPULoadCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          (!_unref(agentsTableUtils).isCloudAgentInStatusStoppedOrUpdating(__props.agentsQueryResult?.agents[index] || {}))
                            ? (_openBlock(), _createBlock(TableCell, {
                                key: 0,
                                value: `${__props.agentsQueryResult?.agents[index]?.performance?.usedCPU}%`,
                                onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                              }, null, 8, ["value", "onContextmenu"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-SubscribedCoresTotal": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.LicensedAgentsCoresCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          (!_unref(agentsTableUtils).isCloudAgentInStatusStoppedOrUpdating(__props.agentsQueryResult?.agents[index] || {}))
                            ? (_openBlock(), _createBlock(TableCell, {
                                key: 0,
                                value: `${__props.agentsQueryResult?.agents[index]?.license?.registeredCores} / ${__props.agentsQueryResult?.agents[index]?.performance?.cpuPhysical}`,
                                onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                              }, null, 8, ["value", "onContextmenu"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-VMType": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.portCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        status: __props.agentsQueryResult?.agents[index]?.status,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: _unref(agentsTableUtils).getContentForCloudStoppedAgents(__props.agentsQueryResult?.agents[index] || {}, __props.agentsQueryResult?.agents[index]?.cloud?.vmType),
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "status", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-Spot": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.portCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        status: __props.agentsQueryResult?.agents[index]?.status,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: _unref(agentsTableUtils).getContentForCloudStoppedAgents(__props.agentsQueryResult?.agents[index] || {}, spotValue(index)),
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "status", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-HDType": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.portCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        status: __props.agentsQueryResult?.agents[index]?.status,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: _unref(agentsTableUtils).getContentForCloudStoppedAgents(__props.agentsQueryResult?.agents[index] || {}, __props.agentsQueryResult?.agents[index]?.cloud?.hdType),
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "status", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-VolumeSize": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.portCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        status: __props.agentsQueryResult?.agents[index]?.status,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: _unref(agentsTableUtils).getCloudAgentVolumeSize(__props.agentsQueryResult?.agents[index] || {}),
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "status", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-CacheSize": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.portCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        status: __props.agentsQueryResult?.agents[index]?.status,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: _unref(agentsTableUtils).getCloudCacheSize(__props.agentsQueryResult?.agents[index] || {}),
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "status", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-AvailabilityZone": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.portCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        status: __props.agentsQueryResult?.agents[index]?.status,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: _unref(agentsTableUtils).getContentForCloudStoppedAgents(__props.agentsQueryResult?.agents[index] || {}, __props.agentsQueryResult?.agents[index]?.cloud?.zone),
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "status", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                "content-CloudCores": _withCtx(({ index }: { index: number }) => [
                  (__props.agentsQueryResult?.agents)
                    ? (_openBlock(), _createBlock(CellWrapper, {
                        key: 0,
                        "data-cy-agent-name": __props.agentsQueryResult?.agents[index]?.name,
                        "data-testid": _unref(elementIds).agents.table.portCell,
                        "agent-metadata": __props.agentsQueryResult?.agents ? __props.agentsQueryResult?.agents[index]?.metadata : undefined,
                        status: __props.agentsQueryResult?.agents[index]?.status,
                        selected: (__props.agentsQueryResult?.agents && _unref(selectedAgents)?.selectedAgentIds.value.has(__props.agentsQueryResult?.agents[index]?.id || '')) || false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TableCell, {
                            value: __props.agentsQueryResult?.agents[index]?.cloud?.numberOfCores || '',
                            onContextmenu: _withModifiers(($event: any) => (handleOpenContextMenu(index)), ["prevent"])
                          }, null, 8, ["value", "onContextmenu"])
                        ]),
                        _: 2
                      }, 1032, ["data-cy-agent-name", "data-testid", "agent-metadata", "status", "selected"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["model-value", "row-height", "data-testid", "class", "columns", "items", "hovered-row-prop"]))
            : (_openBlock(), _createBlock(EmptyAgentsSearch, {
                key: 1,
                "search-items-name": "agents",
                "has-filters-applied": _unref(isSearchFilterApplied),
                class: "flex-grow w-full h-0 bg-System/app_white border-System/app_border border",
                onClearFilters: clearFilters
              }, null, 8, ["has-filters-applied"])),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_unref(totalAgentsCount))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(totalAgentsCount)?.toLocaleString()), 1),
                    (_unref(totalAgentsCount) === 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, " agent"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, " total agents"))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, "No agents for display")),
              (_unref(showAgentsTotalInFiltersCount))
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(totalFilteredAgentsCount)?.toLocaleString()), 1),
                      _hoisted_15
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(selectedAgents)?.selectedAgentIds.value.size)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(selectedAgents)?.selectedAgentIds.value.size), 1),
                      _hoisted_19
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(selectedAgents)?.selectedAgentIds.value.size)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createVNode(_unref(IncrediButton), {
                      "data-testid": "clear-all-selected-agents",
                      design: "master",
                      size: "small",
                      class: "!p-0",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(selectedAgents)?.clearSelection()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_21
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_unref(IncrediPagination), {
                  "model-value": _unref(agentsQueryFilter).get.value.paging.pageNumber,
                  "page-size": Math.ceil((_unref(totalFilteredAgentsCount) || 0) / _unref(agentsQueryFilter).get.value.paging.pageSize),
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = (pageNumber) => { _unref(agentsQueryFilter) &&  _unref(agentsQueryFilter).set({ ..._unref(agentsQueryFilter)?.get.value, paging: { ..._unref(agentsQueryFilter).get.value.paging, pageNumber } }) })
                }, null, 8, ["model-value", "page-size"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode(_unref(IncrediSelect), {
                  "model-value": _unref(agentsQueryFilter).get.value.paging.pageSize,
                  direction: "top-middle",
                  size: "tiny",
                  "min-width": 70,
                  items: [50, 100, 150, 200],
                  "override-style": {
              height: '28px',
              paddingLeft: '8px',
              paddingRight: '9px',
            },
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = pageSize=>_unref(agentsTableUtils).handlePageResize(pageSize as typeof agentsQueryFilter.get.value.paging.pageSize))
                }, null, 8, ["model-value"])
              ])
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})